export default __webpack_public_path__ + "static/media/broc-caleb-02-3.0e7248f6.PNG";